
import { DashboardQuickAddButton, DashboardQuickAddButtonType } from "@/utils/dashboard/dashboard-quick-add-button";
import Vue from "vue";
import AppSaleTypeSelect from "@/components/sales/SaleTypeSelect.vue";
import { ISelectItem } from "winfakt-vue-components";
import { getEnumKeys, getEnumValueFromKey } from "@/utils/enum";
import { AuthService, SaleService } from "@/services";

export default Vue.extend({
	data(){
		return {
			buttonType: DashboardQuickAddButtonType.CLIENT,
			numParam: 1
		};
	},
	computed: {
		showParam():boolean {
			if (this.buttonType == DashboardQuickAddButtonType.SALE) return true;
			if (this.buttonType == DashboardQuickAddButtonType.PURCHASE_DOCUMENT) return true;
			return false;
		},
		saleTypeContactGroupId():number {
			if (this.buttonType == DashboardQuickAddButtonType.PURCHASE_DOCUMENT){
				return 2;
			}
			return 1;
		},
		showSaleTypeSelect():boolean {
			if (this.showParam) return true;
			return false;
		},
		typeItems():ISelectItem<DashboardQuickAddButtonType>[]{
			let keys = getEnumKeys(DashboardQuickAddButtonType);
			let result:ISelectItem<DashboardQuickAddButtonType>[] = keys.map(k=>{
				let val:DashboardQuickAddButtonType = getEnumValueFromKey(DashboardQuickAddButtonType, k);
				return {
					text: DashboardQuickAddButton.getLabel(val, "0"),
					value: val
				};
			});

			if (!AuthService.isDevModeEnabled){
				result = result.filter((f)=>f.value != DashboardQuickAddButtonType.PANIC);
			}

			return result;
		}
	},
	watch: {
		buttonType: {
			handler(){
				if (this.showSaleTypeSelect){
					this.numParam = SaleService.getTypes(this.saleTypeContactGroupId)[0].ID;
				}
			}
		}
	},
	methods: {
		close(){
			this.$emit("close");
		},
		confirm(){
			let button = new DashboardQuickAddButton();
			button.Type = this.buttonType;
			button.Param = `${this.numParam}`;
			this.$emit("confirm", button);
			this.close();
		}
	},
	components: {
		AppSaleTypeSelect
	},
	i18nEx: {
		componentPrefix: "components.dashboard"
	},
});
